import React from 'react';
import LOL from '../../assets/image/common/lol_icon.svg';
import LOR from '../../assets/image/common/lor_icon.svg';
import Valorant from '../../assets/image/common/valorant_icon.svg';

export const LolIcon = () => <LOL />;
export const LorIcon = () => <LOR />;
export const ValorantIcon = () => <Valorant />;
